export const TAG_TYPES = {
  LEVEL: 'level',
  PURPOSE: 'purpose',
  OTHER: 'other',
};
